import React from 'react';
import * as R from 'ramda';
import { Box, Button, MenuItem, TextField } from '@material-ui/core';

import { PosPlugin } from '../plugin';

import { getFiscalIntegrationForCountry } from './API/selectors';
import {
  EFSTAConf,
  EFSTAConfCompany,
  EFSTAConfPos,
  EFSTAConfUser,
  EFSTAConfWarehouse,
} from './types/pluginTypes';
import { useConfig } from './useConfig';

// Todo add translations
const ComponentConfiguration: Required<
  PosPlugin<
    EFSTAConf,
    EFSTAConfCompany,
    EFSTAConfWarehouse,
    EFSTAConfPos,
    EFSTAConfUser
  >
>['ComponentConfiguration'] = params => {
  const {
    byLevel: { company, pos },
  } = params;

  const currentConfig = {
    ...company.current,
    endpoint: pos.current?.endpoint,
  };

  const [conf, setConf] = useConfig(currentConfig);

  function saveConfig() {
    const { endpoint, ...rest } = conf;
    company.save(rest);
    pos.save({ endpoint });
  }

  const {
    ComponentConfiguration: Conf,
    getIsConfigValid = () => true,
  } = getFiscalIntegrationForCountry(conf.country);

  function onChange(key: keyof typeof conf) {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      R.pipe(R.path(['target', 'value']), R.assoc(key), setConf)(event);
    };
  }

  const configIsValid = getIsConfigValid(conf);

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="column" gridGap="1rem">
        <Button
          variant="contained"
          color="secondary"
          style={{ marginLeft: 'auto' }}
          disabled={R.equals(currentConfig, conf) || !configIsValid}
          onClick={saveConfig}
        >
          Save
        </Button>
        <TextField
          fullWidth
          variant="outlined"
          value={conf.country ?? ''}
          select
          onChange={onChange('country')}
          label="Select country"
        >
          <MenuItem disabled value="">
            -
          </MenuItem>
          <MenuItem value="DE">Deutschland</MenuItem>
          <MenuItem value="AT">Austria</MenuItem>
        </TextField>
        <TextField
          fullWidth
          placeholder="https://localhost.erply.com:10123/"
          label="Custom endpoint to use (leave blank if using EFSTA via installer)"
          value={conf?.endpoint ?? ''}
          variant="outlined"
          onChange={onChange('endpoint')}
        />
      </Box>
      {/*
       // @ts-ignore - ts does not like Conf return type */}
      <Conf {...params} currentConfig={conf} onChange={onChange} />
    </Box>
  );
};

export default ComponentConfiguration;
